/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
"use client"

import { memo } from "react"
import { useFormContext } from "react-hook-form"

import { cn } from "@productlane/lib/src/cn"

import type { InputProps } from "./input"
import { get } from "../../../helpers"
import { Input } from "./input"

type FormInputProps = InputProps

export const FormInput = memo(({ name, type, ...props }: FormInputProps) => {
	const {
		formState: { errors },
		register,
	} = useFormContext()
	const error = get(errors, name)
	return (
		<Input
			errorMessage={error ? String(error.message) : undefined}
			{...props}
			className={cn("", props.className)}
			type={type}
			{...register(name, {
				onChange: (event) => {
					if (props.onChange) {
						props.onChange(event)
					}
				},
				onBlur: (event) => {
					if (props.onBlur) {
						props.onBlur(event)
					}
				},
			})}
		/>
	)
})
